import { Box, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import { FormattedMessage } from "react-intl";

type Props = {
  marginBottom?: number;
};

export function FormErrorAlert({ marginBottom }: Props) {
  return (
    <Box marginBottom={marginBottom}>
      <Alert severity="error">
        <Typography variant="body2">
          <FormattedMessage
            id="formErrorAlert.defaultMessage"
            defaultMessage="Something went wrong, please try again. If the problem persists please contact support."
          />
        </Typography>
      </Alert>
    </Box>
  );
}
